module.exports = __webpack_public_path__ + "static/img/8.2f38ed0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/eng/8.png
// module id = 9WJH
// module chunks = 0